import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface ITopicsEndpoints {
    table: string;
    excel: string;
    keywordsExpansion: string;
}

const keywordResearchEndpoints: ITopicsEndpoints = {
    table: "/api/WebsiteTopics/Table",
    excel: "/api/WebsiteTopics/Excel",
    keywordsExpansion: "/api/WebsiteTopics/KeywordsExpansion",
};

const searchAdvertisingEndpoints: ITopicsEndpoints = {
    table: "/api/AdIntelligence/Search/WebsiteTopics/Table",
    excel: "/api/AdIntelligence/Search/WebsiteTopics/Excel",
    keywordsExpansion: "/api/AdIntelligence/Search/WebsiteTopics/KeywordsExpansion",
};

const topicsEndpointsMap: Record<string, ITopicsEndpoints> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    search_website_topics: keywordResearchEndpoints,
    [ROUTES.topics]: searchAdvertisingEndpoints,
    // Sales Intelligence mirror of Search Advertising topics — same endpoints.
    [SI_SEARCH_ROUTES.topics]: searchAdvertisingEndpoints,
};

export const useTopicsEndpoints = (): ITopicsEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = topicsEndpointsMap[state.name];

    if (!endpoints) {
        throw new Error(
            `No topics endpoints configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(topicsEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
